<div
  class="viewer-content"
  [class.img-container]="
    file.contentType === fileType.Img || file.contentType === fileType.Video
  "
  [ngClass]="{
    'img-container':
      file.contentType === fileType.Img || file.contentType === fileType.Video,
  }"
>
  <app-media-player
    *ngIf="file.contentType === fileType.Video"
    [file]="file"
  ></app-media-player>

  <div
    [ngStyle]="{ background: 'url(' + source + ') no-repeat center center' }"
    class="img"
    *ngIf="file.contentType === fileType.Img && source"
  ></div>

  <iframe
    class="embed-pdf"
    *ngIf="file.contentType === fileType.Doc && pdfSource && !pdfError"
    [src]="pdfSource"
    style="display: block; width: 100%; height: calc(100vh - 100px); border: none;"
  ></iframe>

  <div
    class="error-message"
    *ngIf="
      (file.contentType === fileType.Img && !source) ||
      (file.contentType === fileType.Doc && !pdfSource) ||
      pdfError
    "
  >
    <p>Unable to load file. The file may be missing or corrupted.</p>
  </div>

  <div class="cover-description" *ngIf="file.coverPage">
    {{ file.description }}
  </div>

  <app-asset-action
    [asset]="file"
    [status]="hoverState"
    [type]="'viewer'"
    class="file-action"
    *ngIf="!hide"
  >
  </app-asset-action>
</div>
